"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentagePrecision = exports.PricePrecision = exports.currencyFormatMap = void 0;
var region_1 = require("../region");
/** 地区货币格式映射表 */
exports.currencyFormatMap = (_a = {},
    _a[region_1.CidMap.id] = {
        locale: 'id-ID',
        currency: 'IDR',
        minimumFractionDigits: 0,
    },
    _a[region_1.CidMap.th] = {
        locale: 'th-TH',
        currency: 'THB',
        minimumFractionDigits: 2,
    },
    _a[region_1.CidMap.my] = {
        locale: 'ms-MY',
        currency: 'MYR',
        minimumFractionDigits: 2,
    },
    _a[region_1.CidMap.tw] = {
        locale: 'zh-TW',
        currency: 'TWD',
        minimumFractionDigits: 0,
    },
    _a[region_1.CidMap.vn] = {
        locale: 'vi-VN',
        currency: 'VND',
        minimumFractionDigits: 0,
    },
    _a);
/** 为了避免精度丢失，后端保存数字是实际数值的十万倍 */
exports.PricePrecision = '100000';
/** 百分比的精度数值是100 */
exports.PercentagePrecision = '100';
